import { XCircle } from '@magnetic/icons';
import React from 'react';
import { InputFunctionalButton } from './input-functional-button.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const InputClearButton = /* @__PURE__ */ __name(({
  onClear
}) => /* @__PURE__ */ React.createElement(InputFunctionalButton, {
  "aria-label": "Clear Input",
  onClick: onClear
}, /* @__PURE__ */ React.createElement(XCircle, {
  "aria-hidden": true,
  size: 16
})), "InputClearButton");
InputClearButton.displayName = "Input.ClearButton";

export { InputClearButton };
//# sourceMappingURL=input-clear-button.js.map
